<!-- Review Page -->
<div *ngIf="!meetingDate; else confirmationPage">
    <app-header title="self-serve.bookACall.bookYour45"></app-header>
    <p
        class="text-color-secondary-font margin-bottom-6"
        [innerHTML]="'self-serve.bookACall.bookYour45Info' | translate"
    ></p>

    <ui-card class="payroll-timeline-card" [class.loading]="isLoading" variant="outline">
        <app-segment-header title="{{ 'self-serve.bookACall.yourPayrollTimeline' | translate }}">
            <ui-button class="buttons" type="link" (click)="trackSelfServeChangePayrollTimeline()">
                {{ 'self-serve.bookACall.change' | translate }}
            </ui-button>
        </app-segment-header>
        <div class="responsive-grid">
            <div class="row">
                <div>{{ 'self-serve.bookACall.firstPaydayDate' | translate }}</div>
                <div class="text-align-right">
                    {{
                        selfServeOnboarding.firstPaydayDateUndecided
                            ? ('self-serve.undecided' | translate)
                            : (selfServeOnboarding.firstPaydayDate | appDate: 'mediumDate')
                    }}
                </div>
            </div>
            <div *ngIf="selfServeOnboarding.lastPaydayDate" class="row">
                <div>{{ 'self-serve.bookACall.lastPaydayDate' | translate }}</div>
                <div class="text-align-right">{{ selfServeOnboarding.lastPaydayDate | appDate: 'mediumDate' }}</div>
            </div>
            <div *ngIf="selfServeOnboarding.endDateOfLastPayPeriod" class="row">
                <div>{{ 'self-serve.bookACall.endDateOfLastPayPeriod' | translate }}</div>
                <div class="text-align-right">
                    {{ selfServeOnboarding.endDateOfLastPayPeriod | appDate: 'mediumDate' }}
                </div>
            </div>
            <div class="row">
                <div>{{ 'self-serve.bookACall.paydayFrequency' | translate }}</div>
                <div class="text-align-right">
                    {{ 'self-serve.' + selfServeOnboarding.paydayFrequency | translate }}
                </div>
            </div>
        </div>
    </ui-card>

    <ui-card class="payroll-timeline-card" [class.loading]="isLoading" variant="outline">
        <app-segment-header title="{{ 'self-serve.bookACall.paymentInformation' | translate }}">
            <ui-button class="buttons" type="link" (click)="trackSelfServeChangePaymentInformation()">
                {{ 'self-serve.bookACall.change' | translate }}
            </ui-button>
        </app-segment-header>

        <!-- card on file -->
        <ng-container *ngIf="card">
            <div class="responsive-grid">
                <!-- card and expiry -->
                <div class="row">
                    <div class="flex">
                        <img
                            class="margin-right-2"
                            [src]="
                                BRAND_LOGOS[card.brand]
                                    ? '/assets/img/billing/cards/' + BRAND_LOGOS[card.brand]
                                    : undefined
                            "
                        />
                        <div>
                            <strong>{{ card.brand }} ****{{ card.last4 }}</strong>
                        </div>
                    </div>
                    <div class="text-align-right">
                        {{ 'settings.payment-information.expiryLabel' | translate }} {{ card.expMonth }} /{{
                            card.expYear
                        }}
                    </div>
                </div>
            </div>

            <!-- billing address -->
            <div class="margin-top-3 margin-bottom-1">
                <strong>{{ 'settings.payment-information-form.billingAddressLabel' | translate }}:</strong>
            </div>
            <ng-container *ngIf="card.addressLine1; else noBillingAddress">
                <div class="text-color-secondary-font">{{ card.name }}</div>
                <div class="text-color-secondary-font">{{ card.addressLine1 }}</div>
                <div class="text-color-secondary-font">
                    {{ card.addressCity }}, {{ card.addressState }}{{ card.addressZip }}
                </div>
                <div class="text-color-secondary-font">{{ card.addressCountry }}</div>
            </ng-container>
            <ng-template #noBillingAddress>
                {{ 'settings.payment-information.noBillingAddressMessage' | translate }}
            </ng-template>
        </ng-container>

        <!-- no card on file -->
        <div *ngIf="!card && !isLoading" variant="outline">
            {{ 'settings.payment-information.noPaymentMethodMessage' | translate }}
        </div>
    </ui-card>

    <div class="flex justify-center">
        <app-self-serve-calendar-button (meetingDate)="meetingDate = $event" />
    </div>
</div>

<!-- Confirmation Page -->
<ng-template #confirmationPage>
    <app-header title="self-serve.bookACall.guidedSessionBooked"></app-header>
    <p class="text-color-secondary-font" [innerHTML]="'self-serve.bookACall.onThisCall' | translate"></p>
    <p
        class="text-color-secondary-font margin-bottom-6 reschedule-link"
        [innerHTML]="
            'self-serve.bookACall.needToReschedule'
                | translate
                    : { contactLink: 'https://www.humi.ca/contact-general', date: rescheduleDate | appDate: 'full' }
        "
        (click)="handleClick($event)"
    ></p>
    <ui-card id="meetingDateCard" class="payroll-timeline-card" variant="outline">
        <div class="ui">
            <h3 class="margin-bottom-2">{{ 'self-serve.bookACall.dateAndTime' | translate }}</h3>
            <p class="subtext">🗓️ {{ meetingDate | appDate: 'full' }}</p>
        </div>
    </ui-card>
</ng-template>
